/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clients_Comm_None_PrefsInputs */

const cs_clients_comm_none_prefs = /** @type {(inputs: Clients_Comm_None_PrefsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zatím žádné preference — vznikají s klientem`)
};

const en_clients_comm_none_prefs = /** @type {(inputs: Clients_Comm_None_PrefsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No preferences yet — they are created with the client`)
};

/**
* | output |
* | --- |
* | "No preferences yet — they are created with the client" |
*
* @param {Clients_Comm_None_PrefsInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const clients_comm_none_prefs = /** @type {((inputs?: Clients_Comm_None_PrefsInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clients_Comm_None_PrefsInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_clients_comm_none_prefs(inputs)
	return cs_clients_comm_none_prefs(inputs)
});